import { render, staticRenderFns } from "./importRecord.vue?vue&type=template&id=74559374&scoped=true&"
import script from "./importRecord.vue?vue&type=script&lang=js&"
export * from "./importRecord.vue?vue&type=script&lang=js&"
import style0 from "./importRecord.vue?vue&type=style&index=0&id=74559374&prod&lang=css&"
import style1 from "./importRecord.vue?vue&type=style&index=1&id=74559374&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74559374",
  null
  
)

export default component.exports